var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBgSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 399,
    viewBox: "0 0 254 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.925 94.4624C253.379 97.166 256.08 107.98 250.678 116.091L204.758 171.516L148.034 241.81L84.5562 321.567L-42.6679 479H-149.993V0H-49.8979L243.925 94.4624ZM-3.61263 162.586C-2.71906 162.139 -1.82549 161.692 -0.931915 161.096C20.5138 149.77 42.5552 139.637 64.5967 130.099L50.8952 84.1992C49.7038 79.4304 53.8738 75.2577 58.6396 77.046L170.038 112.812C174.208 114.004 175.4 118.773 173.017 122.35L152.762 146.79L127.742 177.787L99.7438 212.957C96.7653 216.533 90.8081 215.341 89.6167 211.168L84.851 194.478L76.511 169.441C74.1281 170.038 71.1495 171.23 68.7667 172.422C67.5753 172.72 66.2349 173.167 64.8945 173.614C63.5542 174.061 62.2138 174.508 61.0224 174.806C59.831 175.104 58.6395 175.552 57.4481 175.999C56.2567 176.446 55.0652 176.893 53.8738 177.191C50.8952 178.383 47.9167 179.575 44.9381 180.171L36.0024 183.748C34.811 184.046 33.7685 184.493 32.726 184.94C31.6835 185.387 30.641 185.834 29.4495 186.132C27.2138 187.127 24.9781 188.017 22.7856 188.891C19.7203 190.112 16.7394 191.299 13.961 192.689C12.1738 193.584 10.3867 194.329 8.59955 195.074C6.81239 195.819 5.02524 196.564 3.23808 197.458C0.259506 198.65 -6.29335 201.631 -6.29335 201.631V164.077C-5.39978 163.48 -4.50621 163.033 -3.61263 162.586Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.472 100.57C210.807 102.954 213.189 112.492 208.426 119.644L167.94 168.522L117.928 230.513L61.9624 300.849L-79.2628 479H-149.993V0H-110.272L202.472 100.57ZM-3.61263 162.586C-2.71906 162.139 -1.82549 161.692 -0.931915 161.096C20.5138 149.77 42.5552 139.637 64.5967 130.099L50.8952 84.1993C49.7038 79.4305 53.8738 75.2578 58.6396 77.0461L170.038 112.812C174.208 114.004 175.4 118.773 173.017 122.35L152.762 146.79L127.742 177.787L99.7438 212.957C96.7653 216.533 90.8081 215.341 89.6167 211.169L84.851 194.478L76.511 169.442C74.1281 170.038 71.1495 171.23 68.7667 172.422C67.5753 172.72 66.2349 173.167 64.8945 173.614C63.5542 174.061 62.2138 174.508 61.0224 174.806C59.831 175.104 58.6395 175.552 57.4481 175.999C56.2567 176.446 55.0652 176.893 53.8738 177.191C50.8952 178.383 47.9167 179.575 44.9381 180.171L36.0024 183.748C34.811 184.046 33.7685 184.493 32.726 184.94C31.6835 185.387 30.641 185.834 29.4495 186.132C27.2138 187.127 24.9781 188.017 22.7856 188.891C19.7203 190.112 16.7394 191.299 13.961 192.689C12.1738 193.584 10.3867 194.329 8.59955 195.074C6.81239 195.819 5.02524 196.564 3.23808 197.458C0.259506 198.65 -6.29335 201.631 -6.29335 201.631V164.077C-5.39978 163.481 -4.50621 163.033 -3.61263 162.586Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 253.431,
    y1: 123.148,
    x2: -37.4901,
    y2: 202.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 210.854,
    y1: 123.148,
    x2: -97.4176,
    y2: 206.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgSm);
export default __webpack_public_path__ + "static/media/login-bg-sm.12ef2b2ef134180d76d982cd03c99985.svg";
export { ForwardRef as ReactComponent };